import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import TransactionCard from "./TransactionCard";
import InfoCircle from "../../../../../media/images/icons/info-circle";

interface Props {
  show: boolean;
}

export default function Transactions({ show }: Props) {
  const theme = useTheme();
  const divRef = useRef<HTMLDivElement>(null);

  const [dragable, setDragable] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    console.log(count);
  }, [count]);
  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        // console.log(divRef.current.scrollTop);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100%",
        backgroundColor: "info.light",
        overflow: "hidden",
        paddingX: "8px",
        paddingTop: "8px",
        transition: "height 0.3s",
        marginTop: "8px",
        // border: "1px solid gray",
        width: "100%",
        zIndex: "1",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          height: "4px",
          width: "30px",
          backgroundColor: "info.main",
          borderRadius: "2px",
          mx: "auto",
        }}
      ></Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            تراکنش‌ها
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "3px",
            }}
          >
            <InfoCircle size={16} color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontSize: "12px",
                color: "primary.main",
              }}
            >
              برای مشاهده جزئیات هر تراکنش روی آن ضربه بزنید.
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        ></Box>
      </Box>
      <Box
        ref={divRef}
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingY: "8px",
          paddingX: "4px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
        <TransactionCard />
      </Box>
    </Box>
  );
}
